import React from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

import { MetaTags } from 'src/components/MetaTags';
import { Unless } from 'src/components/helpers';
import { ConsentManager } from 'src/containers/ConsentManager';
import Footer from 'src/components-v3/Footer';

// helpers
import { AnalyticsProvider, LocaleContext } from 'src/contexts';
import { CmsThemeContextProvider } from 'src/contexts/CmsThemeContext/CmsThemeContextProvider';
import { CmsThemes, Locales } from 'src/lib/constants';
import SiteNavigation from 'src/components-v3/SiteNavigation/SiteNavigation';

// dynamically import the scripts component which invokes all of our js dependencies
const DocsScripts = dynamic(
  () => {
    return import('./DocsScripts');
  },
  {
    ssr: false,
  },
);

// For legal, developer policy, terms-of-use, DPR forms
const DocsTemplate = ({ children, locale = Locales.EN_US, ...props }) => {
  const { route } = useRouter();

  return (
    <LocaleContext.Provider value={locale}>
      <AnalyticsProvider>
        <MetaTags {...props} />
        <CmsThemeContextProvider cmsTheme={CmsThemes.WEB3}>
          <SiteNavigation locale={locale} skipLinkAnchor='#docsArticle' />
        </CmsThemeContextProvider>
        {children}
        <Unless condition={props && props['exclude-footer']}>
          <Footer />
        </Unless>
        <ConsentManager />
        <DocsScripts route={route} />
      </AnalyticsProvider>
    </LocaleContext.Provider>
  );
};
export default DocsTemplate;
